import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import { MobileInwinsFilters } from '../mobileInwinsFilters'

import * as styles from './styles'

const MobileInwinsHeaderComponent = ({
	title = 'History',
	activeTab,
	onTabChange,
}) => {
	return (
		<div css={styles.headerContainer}>
			{/* Header */}
			<div css={styles.header}>
				<div css={styles.logoAndTitleContainer}>
					<img
						src="./img/inwin-tiny-white-logo.png"
						alt="InWin Logo"
						css={styles.logoImage}
					/>
					<Text size={20} bold css={styles.title}>
						{title}
					</Text>
				</div>
			</div>

			{/* Tabs */}
			<div css={styles.tabsContainer}>
				<div css={styles.tabsWrapper}>
					<MobileInwinsFilters
						activeTab={activeTab}
						onTabChange={onTabChange}
					/>
				</div>
			</div>
		</div>
	)
}

MobileInwinsHeaderComponent.propTypes = {
	title: PropTypes.string,
	activeTab: PropTypes.string.isRequired,
	onTabChange: PropTypes.func.isRequired,
}

export default MobileInwinsHeaderComponent 